import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { resolveBrandSettings } from './brandSettings';
import resolveImageUrl from '../../utils/resolveImageUrl';

export default function BrandHead() {
  const branding = useSelector((state) => state.branding?.settings);
  const brand = resolveBrandSettings(branding);
  const faviconUrl = resolveImageUrl(brand.favicon.url);
  const faviconType = brand.favicon.format === 'svg' ? 'image/svg+xml' : brand.favicon.format === 'ico' ? 'image/x-icon' : `image/${brand.favicon.format || 'png'}`;

  return (
    <Helmet>
      <link rel="icon" type={faviconType} href={faviconUrl} />
      <link rel="apple-touch-icon" href={faviconUrl} />
      <meta name="application-name" content={brand.brandName} />
      <meta property="og:site_name" content={brand.brandName} />
    </Helmet>
  );
}
